module.exports = __webpack_public_path__ + "static/media/sf_100_gray.100537823c71c0bcd28f99a9c97c6fe3.png";